export const request = (path, method, body, useApi = true) => {
  return fetch(`${process.env.BE_URL}${useApi ? process.env.API_PATH : ''}${path}`, {
    method,
    headers: {
      'Content-Type': 'application/json'
    },
    credentials: 'include',
    body: body && JSON.stringify(body)
  })
    .then(res => Promise.all([res.ok, res.json()]))
    .then(([ok, json]) => {
      if(!ok) throw json;
      return json;
    });
};
